/* TS Sliping per post (Organic V3, 11/10 2026). Porteret fra mobilutkastet Main.dc.html, vanilla JS uten rammeverk.
   Data kommer fra <script type="application/json" id="ts-slp-data"> i sections/ts-sliping-post.liquid:
   varianter på produktsiden (antall kniver × forsendelse) og våtsteinslip-tillegget (via SKU). Priser i øre.
   Selvbetjente tilleggstjenester er fjernet: reparasjoner og ønsker avtales i handlekurven («Spesielle ønsker»).
   Slipepakke er en variant (valg 2) av samme produkt: pakkeprisen er prisforskjellen mellom Slipepakke og Sender selv for samme antall.
   Har produktet bare ett valg (antall), finnes ingen slipepakke og steg 3 viser bare «Jeg sender selv».
   Frakt betales i kassen og legges ikke i kurven. Returfrakt vises som estimat.
   Runde 85 (20/10 2026): returfrakten (Sender selv) er en egen varelinje i kurven, lagt inn i samme /cart/add.js som slipingen
   når regelen i ts-cart-addons.js sier det (window.__tsCartAddons.retur). Kurven holder regelen etterpå. */
(function () {
  'use strict';

  var root = document.getElementById('ts-slp');
  var dataEl = document.getElementById('ts-slp-data');
  if (!root || !dataEl) return;

  /* Kundetekster fra locales via snippets/ts-tekst.liquid (window.tsTekst), så /en/ kan oversettes. */
  var T = (window.tsTekst || {}).sliping_post || {};
  function fyll(s, vars) { return String(s).replace(/{{\s*(\w+)\s*}}/g, function (_, k) { return vars[k]; }); }
  function q(key) { return root.querySelector('[data-ts="' + key + '"]'); }
  function qa(key) { return root.querySelectorAll('[data-ts="' + key + '"]'); }

  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { D = null; }
  if (!D || !D.variants || !D.variants.length) {
    var fe = q('data-feil');
    if (fe) fe.hidden = false;
    return;
  }

  /* --- Silhuetter (fra utkastet) --- */
  // Knivsilhuettene er lagret komprimert. x: øvre kant har steg på 1,6 eller 1,5 og nedre kant er speilbildet (g = antall
  // steg à 1,6 mellom hvert steg à 1,5). y: verdier i tidels enhet, gjentakelser som verdi x antall.
  var KNIVER_PACKED = {"gyuto":{"x":40,"g":"4,10,9,9,8,10,9,9,9,9,9,9,9,9,9,9,9,9,9,0","y":"192,165x17,171x25,176x19,181x8,202x10,208x14,213x10,218x9,224x15,229x11,234x10,240x6,245x4,250x3,255x2,261x2,266x2,271,277,282x2,287,293,298,303,314,319,324,330,335,346,356,361,372,383,393,409,414,420,425,430,436,441,446,452,457,462,467,473,478x2,483,489x2,494,499x2,505x2,510x2,515,520x2,526x3,531x3,536x4,542x3,547x4,552x5,558x4,563x4,568x4,573x5,579x5,584x6,589x13,595x21,388,367x2,361,356,377x7,383x61,377,361","vb":"13.5 -302.7 49.0 301.7","w":12.7,"h":78.4},"santoku":{"x":40,"g":"4,10,9,9,8,10,9,9,9,9,9,9,9,9,9,9,6","y":"263,168x41,173x22,179,200x62,205x5,210x3,216x3,221x2,226x2,232,237x2,242,248,253,258,263,269,279,285,295,306,316,327,338,348,364,375,391,412,422,428,433,438,444,449,454,460x2,465,470x2,475x2,481,486x2,491x2,497x2,502x2,507x2,513x2,518x3,523x2,528x3,534x3,539x4,544x5,550x4,555x4,560x5,565x5,571x5,576x6,581x6,587x7,592x3,581,369,354x3,348,369,375x27,380x35,375,290","vb":"13.8 -264.6 48.4 263.6","w":12.6,"h":68.5},"nakiri":{"x":40,"g":"4,10,9,9,8,10,9,9,9,9,9,9,9,9,9,9,9,8","y":"176,149x25,155x32,160x14,187x12,181x41,176x21,171x27,181,452,568,573,579x2,584x6,589x8,595x8,600x11,605x16,611x41,605x4,595,351x2,346x2,361x40,367x31,319","vb":"11.9 -283.7 52.2 282.7","w":13.6,"h":73.5},"petty":{"x":40,"g":"4,10,9,9,8,10,9,9,9,9,9,9,9,9,5","y":"298,255,250x56,255,277x5,271x64,277x3,282x2,287,293x2,298,303,314,319,330,335,346,351,361,367,372,377,383,388,393x2,399,404,409x2,414,420x2,425,430x2,436x2,441x3,446x2,452x2,457x3,462x3,467x3,473x3,478x3,483x4,489x5,494x5,499x4,505x7,510x9,420,404x4,420x5,425x20,430x17,436x16,388","vb":"22.0 -231.2 32.0 230.2","w":8.3,"h":59.9},"sujihiki":{"x":40,"g":"4,10,9,9,8,10,9,9,9,9,9,9,9,9,9,9,9,9,9,9,8,6","y":"335,298,282,266,255,250,245x94,240x26,245x42,250x8,255x6,261x4,266x4,271x4,277x2,282x3,287x2,293x2,298x2,303x2,308,314,319,330,340,346,351,356,361,367,372,377,383x2,388,393x2,399x2,404x2,409x2,414x2,420x3,425x2,430x3,436x3,441x3,446x3,452x3,457x4,462x4,467x4,473x6,478x7,483x11,489x12,494x13,499x19,505x17,436,420,425x3,430x3,436x3,441x3,446x3,452x4,457x6,462x25,467,473x2,478,483,489,499,505,515,520x3,515,510,505,499,494,483,473,462,446,425,393","vb":"21.0 -342.5 34.0 341.5","w":8.8,"h":88.8},"deba":{"x":40,"g":"4,10,9,9,8,10,9,9,9,9,9,9,9,9,9,9,8","y":"141,120,115x38,120x11,126x16,131,168,163x11,157x10,152,157x13,163x7,168x6,173x4,179x3,184x3,189x2,194x2,200x2,205x2,210,216x2,221,226x2,232,237,242,248,253,258,263,269,274,285,290,295,306,311,322,327,338,348,359,364,375,385,396,412,433,444,449,454,460,465,470,475,481,486,491,497,502,507,513x2,518,523,528x2,534,539x2,544,550x2,555x2,560,565x2,571x2,576x2,581x3,587x2,592x2,597x3,603x3,608x3,613x4,619x4,624x5,629x6,634x8,640x7,645x4,640,380,338,322,316,311,306x2,332x7,338x8,343x4,348x11,354x13,359x15,364x8,359,306","vb":"8.5 -267.8 59.0 266.8","w":15.3,"h":69.4},"yanagiba":{"x":40,"g":"4,10,9,9,8,10,9,9,9,9,9,9,9,9,9,9,9,9,9,9,8,10,5","y":"269,237,226x13,232x26,237,232x2,237x17,242x16,274,258x19,253x17,248x22,242x34,248x17,253x7,258x5,263x3,269x3,274x2,279x3,285,290x2,295,301,306,311,316,322,327,338,343,354,359,364,369,375,380,385x2,391,396,401x2,406x2,412,417x3,422x2,428x2,433x3,438x3,444x3,449x4,454x4,460x4,465x5,470x5,475x6,481x5,486x6,491x6,497x5,502x8,507x8,513x8,518x8,523x10,528x10,534x3,406,401x6,380,375,417x13,422x4,428x13,433x12,438x13,444x13,449x7,444,412","vb":"19.6 -358.4 36.8 357.4","w":9.6,"h":92.9}};
  function pakkUt(k) {
    var xs = [k.x], gaps = k.g.split(',');
    gaps.forEach(function (g, i) {
      var n = parseInt(g, 10);
      while (n--) xs.push(xs[xs.length - 1] + 16);
      if (i < gaps.length - 1) xs.push(xs[xs.length - 1] + 15);
    });
    xs = xs.concat(xs.slice().reverse());
    var ys = [];
    k.y.split(',').forEach(function (r) {
      var p = r.split('x'), n = p[1] ? parseInt(p[1], 10) : 1;
      while (n--) ys.push(parseInt(p[0], 10));
    });
    var d = '';
    for (var i = 0; i < xs.length; i++) {
      d += (i ? ' L' : 'M') + (xs[i] / 10).toFixed(1) + ' ' + (ys[i] / 10).toFixed(1);
    }
    return d + ' Z';
  }
  var KNIVER = {};
  Object.keys(KNIVER_PACKED).forEach(function (n) {
    var k = KNIVER_PACKED[n];
    KNIVER[n] = { d: pakkUt(k), vb: k.vb, w: k.w, h: k.h };
  });
  var REKKE = ['gyuto', 'santoku', 'nakiri', 'petty', 'sujihiki', 'deba', 'yanagiba', 'gyuto'];
  var VIPP = [-6, 4, -3, 7, -5, 3, -7, 5];

  var cfg = D.config || {};
  /* 1/11 2026 (f11): returfrakten er prisen på produktet «Returfrakt, sliping per post» (samme som kurven tar), satt i seksjonen i øre. */
  var RETUR = (Number(cfg.returfraktOre) || 0) / 100;
  var FRI_FRA = Number(cfg.friReturFra) || 0;
  function norm(x) { return String(x == null ? '' : x).trim().toLowerCase(); }
  var VAL_SELV = norm(cfg.valgSelv || 'Sender selv');
  var VAL_PAKKE = norm(cfg.valgPakke || 'Slipepakke');

  /* Runde 85 (20/10 2026): beløp skrives «149,-», ikke «149 kr» (eiervalg, Anton Sport-form). */
  function kr(n) {
    return (Math.round(n * 100) / 100).toLocaleString(T.tallformat, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }
  /* 1/11 2026 (f05): i NOK som før («149,-» på norsk, «149 kr» på engelsk). Andre valutaer (Markets) får valutaens egen form med desimaler,
     ellers ble €34,95 til «34,- / 34 kr». */
  var NOK = !D.currency || D.currency === 'NOK';
  function belop(n) {
    if (NOK) return kr(n) + T.kr;
    try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: D.currency }).format(n); }
    catch (e) { return kr(n) + ' ' + D.currency; }
  }
  /* Tall foran «,-» i markupen (prislinja, metodekortene). Utenfor NOK er suffikset tomt og valutaen står i tallet. */
  function tall(n) { return NOK ? kr(n) : belop(n); }
  /* Fordeling er en egenskap verkstedet leser på ordren, ikke visningstekst: alltid norsk, uansett butikkspråk.
     1/11 2026 (f17): MÅ være tegn for tegn lik fordeling() i ts-sliping-gruppe.js, ellers skriver kurven egenskapen om (ensureFordeling sammenligner tekst). */
  function fordeling(hand, antall) {
    var parts = [];
    if (hand > 0) parts.push(hand + ' våtsteinslip');
    if (antall - hand > 0) parts.push((antall - hand) + ' standard slip');
    return parts.join(', ');
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function setText(key, text) {
    var list = qa(key);
    for (var i = 0; i < list.length; i++) list[i].textContent = text;
  }

  /* --- Data --- */
  /* Valg 1 = antall kniver (tallet i verdien, som kurven og ts-cart-addons.js leser det). Valg 2 (om det finnes) = forsendelse: «Sender selv» eller «Slipepakke». */
  var TO_VALG = !!(D.options && D.options.length > 1);
  var VARIANTER = [];
  var PAKKE_VAR = {};
  D.variants.forEach(function (v, i) {
    var n = parseInt(v.o1, 10) || i + 1;
    var rec = { id: v.id, n: n, pris: v.price / 100, available: v.available !== false };
    if (!TO_VALG) { VARIANTER.push(rec); return; }
    var o2 = norm(v.o2);
    if (o2 === VAL_PAKKE) PAKKE_VAR[n] = rec;
    else if (o2 === VAL_SELV) VARIANTER.push(rec);
  });
  VARIANTER.sort(function (a, b) { return a.n - b.n; });
  if (!VARIANTER.length) {
    var fe2 = q('data-feil');
    if (fe2) fe2.hidden = false;
    return;
  }
  var HAR_PAKKE = TO_VALG && Object.keys(PAKKE_VAR).length > 0;
  var MAKS_ANTALL = VARIANTER.length;
  var PRIS = VARIANTER[0].pris;                    /* standard sliping per kniv = variant 1 */

  var BY_SKU = {};
  (D.tillegg || []).forEach(function (t) {
    /* Utsolgt våtsteinslip kan ikke velges (f-extra 1/11 2026). */
    if (t.sku && t.available !== false) BY_SKU[t.sku] = { id: t.id, sku: t.sku, title: t.title, pris: t.price / 100, available: t.available !== false };
  });
  var VAT = BY_SKU[String(cfg.skuVat || 'SLIP-VAT').trim()] || null;
  var TILLEGG_HAND = VAT ? VAT.pris : 0;
  var HAND_PRIS = PRIS + TILLEGG_HAND;
  var FRI_KR = FRI_FRA * PRIS;                     /* 5 × 149 = 745, samme grense som kurven */

  /* --- Tilstand --- */
  /* Runde 105b (23/10 2026, eiervalg «bedre CTA»): 1 kniv er forhåndsvalgt, så kjøpsknappen og totalen vises med en gang. Før sto det bare grå tekst til kunden trykket på et tall. */
  /* 31/10 2026 (UX-masterplan s1): ingen kniv er forvalgt (kjøpsknappen er grå til antall er valgt), med mindre «Forvelg 1 kniv» er på.
     metode: 'vat' = alle får våtsteinslip (forvalgt, «Anbefalt»), 'std' = alle standard, 'blandet' = hand kniver med våtstein. */
  /* Kurven ved sidelast (fra Liquid), oppdateres ved cart:change nederst. */
  var kurv = { kniver: Number(cfg.kurvKniver) || 0, retur: !!cfg.kurvRetur };
  var state = { antall: Number(cfg.forvalgtAntall) > 0 ? 1 : 0, metode: VAT && cfg.metode !== 'std' ? 'vat' : 'std', hand: 0, frakt: 'selv', busy: false };

  function beregn() {
    var harValgt = state.antall > 0;
    var antall = Math.min(Math.max(state.antall, 1), MAKS_ANTALL);
    var hand = state.metode === 'vat' && VAT ? antall : state.metode === 'blandet' ? Math.min(state.hand, antall) : 0;
    var variant = VARIANTER[antall - 1] || VARIANTER[VARIANTER.length - 1];
    /* Slipepakke = egen variant av samme produkt. Pakkeprisen som vises er prisforskjellen mot Sender selv for samme antall. */
    var pakkeVar = HAR_PAKKE ? (PAKKE_VAR[variant.n] || null) : null;
    var pakkePris = pakkeVar ? Math.max(0, pakkeVar.pris - variant.pris) : 0;
    var medPakke = state.frakt === 'pakke' && !!pakkeVar && pakkeVar.available;
    var kurvVariant = medPakke ? pakkeVar : variant;
    var base = variant.pris;
    var handSum = VAT ? hand * VAT.pris : 0;

    var linjer = [];
    var sliping = fyll(T.linje_sliping, { n: antall });
    if (Math.abs(base - antall * PRIS) < 0.005) sliping += ' ' + fyll(T.linje_a_pris, { pris: belop(PRIS) });
    linjer.push({ tekst: sliping, sum: belop(base) });
    if (hand > 0 && VAT) linjer.push({ tekst: fyll(T.linje_vat, { n: hand, pris: belop(VAT.pris) }), sum: belop(handSum) });

    if (medPakke) linjer.push({ tekst: T.linje_pakke, sum: belop(pakkePris) });

    var kurvTotal = base + handSum + (medPakke ? pakkePris : 0);
    /* Runde 90 (22/10 2026): gratis retur etter beløp, som regelen i kurven (g_retur_fra_kr = 5 × 149), ikke etter antall kniver. */
    /* Runde 106 (25/10 2026, eiervalg): fri returfrakt etter antall kniver (FRI_FRA), uansett slipemetode. Samme regel som kurven. */
    /* 1/11 2026 (f11): knivene som alt ligger i kurven teller med, og ligger returfraktlinja der fra før, kommer ingen ny. Samme regel som returOnske i ts-cart-addons.js. */
    var friRetur = FRI_FRA > 0 && antall + kurv.kniver >= FRI_FRA;
    var returEst = medPakke || friRetur || kurv.retur ? 0 : RETUR;
    var total = kurvTotal + returEst;
    return {
      kurvTotal: kurvTotal,
      harValgt: harValgt, antall: antall, hand: hand, maskin: antall - hand, variant: variant,
      friRetur: friRetur, returIKurv: kurv.retur && !friRetur && !medPakke, returEst: returEst, pakkePris: pakkePris, pakkeVar: pakkeVar, medPakke: medPakke, kurvVariant: kurvVariant,
      linjer: linjer, total: total
    };
  }

  /* --- Bygg DOM (én gang) --- */
  var antallKnapper = [];
  (function bygAntall() {
    var boks = q('antall-valg');
    if (!boks) return;
    VARIANTER.forEach(function (v) {
      var b = el('button', 'ts-slp__pill', String(v.n));
      b.type = 'button';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', 'false');
      if (!v.available) b.disabled = true;
      b.addEventListener('click', function () { settAntall(v.n); });
      boks.appendChild(b);
      antallKnapper.push(b);
    });
  })();

  var sliderAntall = q('antall-slider');
  if (sliderAntall) {
    sliderAntall.max = String(MAKS_ANTALL);
    sliderAntall.addEventListener('input', function () { settAntall(parseInt(sliderAntall.value, 10) || 1); });
    /* Sliderens startverdi er 1: slipp/tastetrykk uten å flytte den skal også velge 1. */
    var forsteValg = function () { if (state.antall === 0) settAntall(parseInt(sliderAntall.value, 10) || 1); };
    sliderAntall.addEventListener('pointerup', forsteValg);
    sliderAntall.addEventListener('keyup', forsteValg);
  }

  function settAntall(n) {
    n = Math.min(Math.max(n, 1), MAKS_ANTALL);
    /* Slideren kan dra over et utsolgt antall; knappene er alt deaktivert (f-extra 1/11 2026). */
    var v = VARIANTER[n - 1];
    if (v && !v.available) { if (sliderAntall) sliderAntall.value = String(state.antall || 1); return; }
    state.antall = n;
    state.hand = Math.min(state.hand, n);
    oppdater();
  }

  /* Radiokort for metode, og − / + for å blande når kunden har flere kniver. */
  var metodeStd = q('metode-std'), metodeVat = q('metode-vat');
  [metodeStd, metodeVat].forEach(function (r) {
    if (r) r.addEventListener('change', function () { if (r.checked) { state.metode = r.value; oppdater(); } });
  });
  function settHand(n) {
    var antall = Math.min(Math.max(state.antall, 1), MAKS_ANTALL);
    n = Math.min(Math.max(n, 0), antall);
    state.hand = n;
    state.metode = n === 0 ? 'std' : n === antall ? 'vat' : 'blandet';
    oppdater();
  }
  var handMinus = q('hand-minus'), handPluss = q('hand-pluss');
  if (handMinus) handMinus.addEventListener('click', function () { settHand(beregn().hand - 1); });
  if (handPluss) handPluss.addEventListener('click', function () { settHand(beregn().hand + 1); });

  var velgSelv = q('velg-selv'), velgPakke = q('velg-pakke');
  if (velgSelv) velgSelv.addEventListener('click', function () { state.frakt = 'selv'; oppdater(); });
  if (velgPakke) velgPakke.addEventListener('click', function () { if (HAR_PAKKE) { state.frakt = 'pakke'; oppdater(); } });

  /* --- Kniv-ikoner --- */
  var SVGNS = 'http://www.w3.org/2000/svg';
  var ikonEls = [];
  function bygIkoner(antall) {
    var boks = q('kniv-ikoner');
    if (!boks) return;
    while (boks.firstChild) boks.removeChild(boks.firstChild);
    ikonEls = [];
    for (var j = 0; j < antall; j++) {
      var k = KNIVER[REKKE[j % REKKE.length]];
      var svg = document.createElementNS(SVGNS, 'svg');
      svg.setAttribute('class', 'ts-slp__kniv');
      svg.setAttribute('width', k.w);
      svg.setAttribute('height', k.h);
      svg.setAttribute('viewBox', k.vb);
      svg.style.transform = 'rotate(' + VIPP[j % VIPP.length] + 'deg)';
      var g = document.createElementNS(SVGNS, 'g');
      g.setAttribute('transform', 'rotate(-90)');
      var path = document.createElementNS(SVGNS, 'path');
      path.setAttribute('d', k.d);
      g.appendChild(path); svg.appendChild(g); boks.appendChild(svg);
      ikonEls.push(path);
    }
  }

  /* --- Oppdater visning --- */
  function sett(e, attr, v) { if (e) e.setAttribute(attr, v); }

  function oppdater() {
    var c = beregn();
    var antall = c.antall;

    setText('pris', tall(PRIS));
    setText('hand-pris', tall(HAND_PRIS));
    setText('antall-overskrift', c.harValgt ? fyll(antall === 1 ? T.antall_kniv : T.antall_kniver, { n: antall }) : T.velg_antall);

    antallKnapper.forEach(function (b, i) { sett(b, 'aria-checked', c.harValgt && VARIANTER[i].n === antall ? 'true' : 'false'); });
    if (sliderAntall && c.harValgt) sliderAntall.value = String(antall);
    /* Steg 2 og 3 står synlige før antall er valgt og viser da prisene for én kniv. */
    /* Steg 2: metode */
    if (metodeStd) metodeStd.checked = state.metode === 'std';
    if (metodeVat) metodeVat.checked = state.metode === 'vat';
    var bland = q('bland'); if (bland) bland.hidden = !VAT || !c.harValgt || antall < 2;
    if (handMinus) handMinus.disabled = c.hand <= 0;
    if (handPluss) handPluss.disabled = c.hand >= antall;
    if (ikonEls.length !== antall) bygIkoner(antall);
    // Runde 84 (20/10 2026): våtstein-ikonene fylles i tekstfargen (stilk), ikke lilla #DFDDFF.
    ikonEls.forEach(function (p, j) { p.setAttribute('fill', j < c.hand ? 'currentColor' : '#ffffff'); });
    setText('sammendrag', (c.hand === 0 || c.maskin === 0)
      ? fyll(antall === 1 ? T.sammendrag_en : antall === 2 ? T.sammendrag_begge : T.sammendrag_alle, { n: antall, metode: c.hand === 0 ? T.standard_slip : T.vatsteinslip })
      : fyll(T.sammendrag_blandet, { vat: c.hand, std: c.maskin }));
    /* Steg 3: forsendelse */
    sett(velgSelv, 'aria-checked', c.medPakke ? 'false' : 'true');
    sett(velgPakke, 'aria-checked', c.medPakke ? 'true' : 'false');
    if (velgPakke) {
      velgPakke.hidden = !(HAR_PAKKE && c.pakkeVar);
      velgPakke.disabled = !!c.pakkeVar && !c.pakkeVar.available;
    }
    /* Runde 90 (22/10 2026): kortet viser returfrakten. Porto inn betaler kunden, det står i teksten under. */
    /* Runde 105d (23/10 2026, eiervalg): «Fri returfrakt» i tomat, samme ord som «Fri frakt over 2 500,-». */
    var friTekst = c.friRetur || RETUR <= 0;
    setText('selv-pris', friTekst ? T.fri_returfrakt : fyll(T.retur_belop, { pris: belop(RETUR) }));
    var selvPris = q('selv-pris'); if (selvPris) selvPris.classList.toggle('ts-slp__fri-retur', friTekst);
    /* Runde 105c (23/10 2026, eiervalg): i antall kniver, ikke kroner. Grensen er FRI_FRA kniver × laveste pris, så «fra 5 kniver» holder for alle blandinger (våtstein når grensen før). */
    setText('selv-retur', FRI_KR > 0 && RETUR > 0 ? fyll(T.fri_retur_fra, { n: FRI_FRA }) : '');
    if (HAR_PAKKE && c.pakkeVar) {
      setText('pakke-pris', belop(c.pakkePris));
      setText('pakke-tekst', T.pakke_tekst);
    }

    /* Oppsummering */
    var lbox = q('linjer');
    if (lbox && !c.harValgt) {
      while (lbox.firstChild) lbox.removeChild(lbox.firstChild);
      var hint = el('div', 'ts-slp__linje ts-slp__linje--dempet');
      hint.appendChild(el('span', null, cfg.ikkeValgt || T.velg_antall));
      lbox.appendChild(hint);
    } else if (lbox) {
      while (lbox.firstChild) lbox.removeChild(lbox.firstChild);
      c.linjer.forEach(function (l) {
        var r = el('div', 'ts-slp__linje');
        r.appendChild(el('span', null, l.tekst)); r.appendChild(el('span', null, l.sum));
        lbox.appendChild(r);
      });
      if (!c.medPakke) {
        var fr = el('div', 'ts-slp__linje ts-slp__linje--dempet');
        /* Runde 85 (20/10 2026): returfrakten legges i kurven som egen linje, betales ikke i kassen. */
        fr.appendChild(el('span', null, T.returfrakt));
        fr.appendChild(el('span', null, c.returIKurv ? (cfg.returIKurven || T.gratis) : c.returEst === 0 ? T.gratis : belop(c.returEst)));
        lbox.appendChild(fr);
      }
    }
    setText('total', c.harValgt ? belop(c.total) : '–');

    var cta = q('cta');
    if (cta) {
      cta.textContent = c.harValgt ? fyll(T.cta, { pris: belop(c.total) }) : (cfg.ctaTom || T.velg_antall);
      cta.disabled = state.busy || !c.harValgt;
      cta.setAttribute('aria-busy', state.busy ? 'true' : 'false');
    }
    var stickyCta = q('sticky-cta'); if (stickyCta && cta) stickyCta.disabled = cta.disabled;
  }

  /* --- Legg i handlekurven --- */
  function bestillingId() {
    return Math.random().toString(36).slice(2, 8) + Date.now().toString(36).slice(-4);
  }
  function visFeil(msg) {
    var f = q('feil');
    if (!f) return;
    f.textContent = msg || '';
    f.hidden = !msg;
  }
  function bundledSections() {
    var list = [];
    try { document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: list } })); } catch (e) {}
    return list;
  }
  function jsonFetch(url, opts) {
    return fetch(url, opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) {
          var err = new Error(j && (j.description || j.message) || ('HTTP ' + r.status));
          err.status = r.status; err.body = j;
          throw err;
        }
        return j;
      });
    });
  }

  function bestill() {
    if (state.busy) return;
    var c = beregn();
    if (!c.harValgt) return;
    var id = bestillingId();

    var items = [{
      id: c.kurvVariant.id, quantity: 1,
      properties: { _bestilling: id, Fordeling: fordeling(c.hand, c.antall) }
    }];
    if (c.hand > 0 && VAT) items.push({ id: VAT.id, quantity: c.hand, properties: { _bestilling: id } });
    state.busy = true;
    visFeil('');
    oppdater();

    var sections = bundledSections();
    var body = { items: items };
    if (sections.length) { body.sections = sections.join(','); body.sections_url = window.location.pathname; }

    var addJson, lagtTil = false;
    /* Runde 85 (20/10 2026): med «Sender selv» leses kurven først. Gir regelen returfrakt og linja mangler, legges den (antall 1)
       i samme kall. Feiler lesingen (eller tar over 2,5 s), legges bare slipingen inn; kurven (ts-cart-addons.js) legger returfrakten til etterpå. */
    var R = window.__tsCartAddons && window.__tsCartAddons.retur;
    var forKurv = R && R.id && !c.medPakke
      ? jsonFetch((D.cartUrl || '/cart') + '.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store',
          signal: window.AbortSignal && AbortSignal.timeout ? AbortSignal.timeout(2500) : undefined }).catch(function () { return null; })
      : Promise.resolve(null);
    forKurv.then(function (forCart) {
      if (forCart && forCart.items && R.onske(forCart, Math.round(c.kurvTotal * 100), true, c.antall) &&
          !forCart.items.some(function (i) { return i.variant_id === R.id; })) {
        items.unshift({ id: R.id, quantity: 1 });   /* først i kallet = under slipingen i kurven (Shopify viser nyeste øverst) */
      }
      return jsonFetch(D.cartAddUrl || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      });
    }).then(function (res) {
      addJson = res;
      lagtTil = true;
      return jsonFetch((D.cartUrl || '/cart') + '.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' });
    }).then(function (cart) {
      if (addJson && addJson.sections) cart.sections = addJson.sections;
      state.busy = false;
      oppdater();
      apneKurv(cart);
    }).catch(function (e) {
      state.busy = false;
      oppdater();
      /* 13/10 2026: bestillingen ligger i kurven selv om noe feilet etterpå (kurvlesing, skuffen). Vis kurven i stedet for
         feilmeldingen, ellers trykker kunden igjen og får to bestillinger. */
      if (lagtTil) { window.location.href = D.cartUrl || '/cart'; return; }
      var msg = e && e.status === 422 && e.message ? e.message : T.feil_kurv;
      visFeil(msg);
    });
  }

  /* Åpner skuffen på samme måte som Prestiges produktskjema: cart:change med baseEvent «variant:add» og kurvdata (med seksjoner).
     Er kurven satt til egen side, eller finnes ingen skuff, går vi til /cart. */
  function apneKurv(cart) {
    var drawer = document.querySelector('cart-drawer');
    if (root.getAttribute('data-cart-type') === 'page' || !drawer) {
      window.location.href = D.cartUrl || '/cart';
      return;
    }
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
    setTimeout(function () {
      if (!drawer.hasAttribute('open') && typeof drawer.show === 'function') {
        try { drawer.show(); } catch (e) { window.location.href = D.cartUrl || '/cart'; }
      }
    }, 400);
  }

  var cta = q('cta');
  if (cta) cta.addEventListener('click', bestill);

  /* Kurven endres i skuffen uten sidelast: les knivene og returfraktlinja på nytt, så totalen følger regelen. */
  document.addEventListener('cart:change', function (e) {
    var cart = e.detail && e.detail.cart;
    if (!cart || !cart.items) return;
    var n = 0, har = false;
    cart.items.forEach(function (i) {
      if (i.product_id === D.product.id) n += (parseInt((i.variant_options || [])[0], 10) || 0) * (i.quantity || 0);
      if (cfg.returVariant && i.variant_id === cfg.returVariant) har = true;
    });
    kurv.kniver = n; kurv.retur = har;
    oppdater();
  });

  oppdater();
})();
